export const testId = {
  addNewSequenceButton: 'add-new-sequence-button',
  archivedSearchForm: 'archived-search-form',
  archivedSearchFormButtonSearch: 'archived-search-form-button-search',
  archivedSearchFormFieldSearchBy: 'archived-search-form-field-search-by',
  archivedSearchFormFieldSearchByPuppyId: 'archived-search-form-field-search-by-puppy-id',
  archivedSearchFormFieldSearchValue: 'archived-search-form-field-search-value',
  fieldGroundTransporter: 'field-ground-transporter',
  fieldGroundTransporterOption: 'field-ground-transporter-option-',
  finalizedTravelPackageButton: 'finalized-travel-package-button',
  packagesTable: 'packages-table',
  seeEligiblePackagesBtn: 'see-eligible-packages-btn',
  seeEligiblePackagesModalContent: 'see-eligible-packages-modal-content',
  sequenceTypeSelect: 'sequence-type-select',
  sequenceTypeOptions: (optionName: string) =>
    `sequence-type-option-${optionName.replace(/\s+/g, '-').toLowerCase()}`,
} as const;
